function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.7 20.139a7.782 7.782 0 1 0-7.782-7.782 7.831 7.831 0 0 0 7.782 7.782zm.844-5.3a1.063 1.063 0 0 1-1.672 0l-2.988-3.19a.672.672 0 0 1-.03-.934.649.649 0 0 1 .949-.008l2.908 3.093 2.908-3.089a.664.664 0 0 1 .957.008.672.672 0 0 1-.03.934z",
  transform: "translate(-.703 -.654)"
});

function SvgArrowFilledDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pdwlwfxgma"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#pdwlwfxgma)"
    }
  }, _ref2));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowFilledDown);
export default __webpack_public_path__ + "static/media/arrow-filled-down.71e5a790.svg";
export { ForwardRef as ReactComponent };